import { Box, Button, TextField } from "@mui/material";
import React from "react";
import { Link } from "react-admin";
import { useTranslate } from "react-admin";
import { useForm } from "react-hook-form";

import { EMAIL_VALIDATION_PATTERN } from "../lib/validation";
import { space } from "../theme/designTokens";
import { AuthFormHeader } from "./AuthFormHeader";

export type ForgotPasswordFormData = {
  email: string;
};

type ForgotPasswordFormProps = {
  loading: boolean;
  defaultEmail?: string;
  onSubmit: (data: ForgotPasswordFormData) => void;
  onBackToLogin: () => void;
};

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  loading,
  defaultEmail,
  onSubmit,
  onBackToLogin,
}) => {
  const translate = useTranslate();

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<ForgotPasswordFormData>({
    mode: "onChange",
    defaultValues: {
      email: defaultEmail || "",
    },
  });

  return (
    <>
      <AuthFormHeader title={translate("forgotPassword.title")} description={translate("forgotPassword.description")} />

      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <TextField
          fullWidth
          label={translate("forgotPassword.email")}
          type="email"
          margin="normal"
          autoComplete="email"
          autoFocus
          disabled={loading}
          required
          error={!!errors.email}
          helperText={errors.email?.message}
          {...register("email", {
            required: translate("forgotPassword.emailRequired"),
            pattern: {
              value: EMAIL_VALIDATION_PATTERN,
              message: translate("forgotPassword.emailInvalid"),
            },
          })}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading || !isValid}
          sx={{ marginTop: `${space.xl}px` }}
        >
          {loading ? translate("forgotPassword.sending") : translate("forgotPassword.submit")}
        </Button>

        <Box sx={{ marginTop: `${space.xl}px` }}>
          <Link
            to="#"
            onClick={e => {
              e.preventDefault();
              onBackToLogin();
            }}
          >
            {translate("forgotPassword.backToLogin")}
          </Link>
        </Box>
      </Box>
    </>
  );
};
